import React, { useEffect, useState } from 'react';
import ValidatingInput from '../ValidatingInput/ValidatingInput';
import { JOKI } from '../../JOKI';

export default function OrganizationParent(props) {
    const [parentOptions, setParentOptions] = useState();

    const defaultOption = { label: 'No Parents', value: null };
    useEffect(() => {
        async function getAvailableParents(id) {
            const results = await JOKI.ask({
                from: 'React:CrudParentLocationDropDown',
                to: props.serviceId,
                key: 'getAvailableParents',
                body: id,
            });

            if (results && results[props.serviceId]) {
                const options = results[props.serviceId] || [];
                options.unshift(defaultOption);
                setParentOptions(options);
            }
        }
        getAvailableParents(props.dataSet.id);
    }, [props.dataSet]);

    let valueObject = null;

    if (Array.isArray(parentOptions)) {
        valueObject = parentOptions.find(pobj => pobj.value === props.dataSet[props.dataKey]) || {};
    }

    return (
        <>
            {valueObject && Array.isArray(parentOptions) && (
                <ValidatingInput
                    label={props.label}
                    dataSet={props.dataSet}
                    dataKey={props.dataKey}
                    valueObject={valueObject}
                    onChange={props.onChange}
                    options={parentOptions}
                    validationFn={(selectedParent) => {
                        return parentOptions.findIndex(p => p.value === selectedParent.value) > -1
                    }}
                    validationType="select"
                />
            )}
        </>

    );
}
